import { createSvgIcon } from '@mui/material';

export const PlusIcon = createSvgIcon(
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.16602 15.8332V10.8332H4.16602V9.1665H9.16602V4.1665H10.8327V9.1665H15.8327V10.8332H10.8327V15.8332H9.16602Z"
      fill="currentColor"
    />
  </svg>,
  'PlusIcon',
);
